import { Box, Button, Container, Grid, Typography } from "@mui/material";
import React from "react";
import Navbar from "../../Components/Navbar";
import top_banner from "../../Assets/Images/top_banner_.png";
import green_circle from "../../Assets/Images/green_circle.png";
import practitioner from "../../Assets/Images/practitioner.png";
import img_1 from "../../Assets/Images/img_1.png";
import img_2 from "../../Assets/Images/img_2.png";
import img_3 from "../../Assets/Images/img_3.png";
import img_4 from "../../Assets/Images/img_4.png";
import img_5 from "../../Assets/Images/img_5.png";
import img_6 from "../../Assets/Images/img_6.png";
import img_7 from "../../Assets/Images/img_7.png";
import blue_circle_left from "../../Assets/Images/blue_circle_left.png";
import blue_circle_right from "../../Assets/Images/blue_circle_right.png";
import CardInfo from "./CardInfo";
import { CardData } from "./CardInfoData";
import CopyRight from "../../Components/CopyRight";
import Footer from "../../Components/Footer";

const Home = () => {
  return (
    <Box>
      <Box position={"relative"}>
        <Typography
          component={"img"}
          src={green_circle}
          sx={{
            position: "absolute",
            top: "0",
            left: "0",
            width: { sm: "75%", xs: "90%" },
            height: "130%",
          }}
        />
        <Navbar />

        <Box
          sx={{
            position: "relative",
          }}
        >
          <Typography
            component={"img"}
            src={top_banner}
            sx={{
              width: "100%",
              height: { sm: "auto", xs: "60vh" },
              objectFit: "cover",
            }}
          />

          <Box
            sx={{
              width: "100%",
              position: "absolute",
              top: { md: "50%", xs: "30%" },
              left: "0",
            }}
          >
            <Container>
              <Box
                sx={{
                  width: { md: "700px", xs: "100%" },
                  textAlign: { md: "start", xs: "center" },
                }}
              >
                <Typography
                  sx={{
                    fontSize: { md: "30px", xs: "20px" },
                    color: "#e2fceb",
                  }}
                >
                  Optimize respiration. Improve breathing habits.
                  <br />
                  Live streaming CO<sub>2</sub> technology and coaching.
                  <br />
                  Originators of CapnoLearning
                  <sup style={{ fontSize: "8px" }}>TM</sup> services.
                </Typography>
                <Button
                  className="btn"
                  sx={{
                    mt: "2rem",
                  }}
                  onClick={() => window.location.replace("/service/individual")}
                >
                  Individual Services
                </Button>
              </Box>
            </Container>
          </Box>
        </Box>
        <Container>
          <Box
            sx={{
              py: "5rem",
              textAlign: "center",
              position: "relative",
              "& p": {
                color: "#000",
              },
            }}
          >
            <Typography
              sx={{
                fontSize: { sm: "30px", xs: "25px" },
              }}
            >
              Discover CapnoLearning<sup style={{ fontSize: "8px" }}>TM</sup>.
            </Typography>
            <Typography
              sx={{
                fontSize: { sm: "25px", xs: "20px" },
              }}
            >
              Better Breathing Habits for
              <br />
              Better Respiration.
            </Typography>
            <Typography
              sx={{
                fontSize: { sm: "25px", xs: "20px" },
                // mt:"1.5rem",
                width: { md: "70%", xs: "100%" },
                m: "2rem auto 0",
              }}
            >
              
            We are the founders of CapnoLearning<sup style={{ fontSize: "8px" }}>TM</sup>,  breathing counseling services that bring together physiology, psychology, and technology for helping people identify and improve breathing habits for optimizing respiration and improving health and performance.
            </Typography>
          </Box>
        </Container>
      </Box>
      <Container>
        <Box
          sx={{
            my: "5rem",
            position: "relative",
          }}
        >
          <Grid container spacing={5}>
            {CardData?.map((data, i) => (
              <Grid item sm={6} xs={12}>
                <CardInfo data={data} key={i} />
              </Grid>
            ))}
          </Grid>
        </Box>
        <Box
          position={"relative"}
          sx={{
            color: "#000",
            zIndex: "2",
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: "1rem",
              alignItems: "center",
            }}
          >
            <Typography sx={{ fontSize: { sm: "30px", xs: "25px" } }}>
              PRACTITIONER SETTINGS
            </Typography>
            <Typography
              component={"img"}
              src={practitioner}
              sx={{
                width: "70px",
                // height:"70px"
              }}
            />
          </Box>
          <Typography sx={{ fontSize: { sm: "25px", xs: "20px" }, pt: "1rem" }}>

            As a practitioner, you recognize that breathing is fundamental to better physiology and can impact service outcomes in professional settings. Our CapnoLearning<sup style={{ fontSize: "8px" }}>TM</sup> services assist providers within their area of specialty when breathing habits can optimize respiration and support provider and client goals. If you would like to learn more about services when breathing habits can facilitate goals, please complete the contact form on our Affiliate service page.
          </Typography>
          {/* <Typography sx={{ fontSize: { sm: "25px", xs: "20px" }, pt: "1rem" }}>
            If you are already a registered practice with CapnoLearning.org
            please click on the Provider link at the top of the page to log in.
          </Typography> */}
        </Box>
      </Container>
      <Box position={"relative"}>
        <Typography
          component={"img"}
          src={blue_circle_left}
          sx={{
            position: "absolute",
            top: {md:"-8%",xs:"0"},
            left: "0",
            width: {md:"40%",xs:"100%"},
            height: {md:"150%",xs:"90%"},
          }}
        />
        <Typography
          component={"img"}
          src={blue_circle_left}
          sx={{
            position: "absolute",
            top: {md:"-42%",xs:"-22%"},
            transform: "rotate(180deg)",
            right: "0",
            width: {md:"40%",xs:"100%"},
            height: {md:"150%",xs:"90%"},
          }}
        />
        <Container>
          <Grid container spacing={1} py={"5rem"} position={"relative"}>
            <Grid item md={4} xs={12}>
              <Typography
                component={"img"}
                src={img_1}
                width={"100%"}
                height={"100%"}
              />
            </Grid>
            <Grid item md={4} xs={12}>
              <Typography
                component={"img"}
                src={img_2}
                width={"100%"}
                height={"100%"}
              />
            </Grid>
            <Grid item md={4} xs={12}>
              <Typography
                component={"img"}
                width={"100%"}
                height={"100%"}
                src={img_3}
              />
            </Grid>
            <Grid item md={4} xs={12}>
              <Typography component={"img"} width={"100%"} src={img_4} />
              <Typography component={"img"} width={"100%"} src={img_5} />
            </Grid>
            <Grid item md={6} xs={12}>
              <Typography
                component={"img"}
                width={"100%"}
                src={img_6}
                height={"100%"}
              />
            </Grid>
            <Grid item md={2} xs={12}>
              <Typography
                component={"img"}
                width={"100%"}
                src={img_7}
                height={"90%"}
              />
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Footer/>
      <CopyRight />
    </Box>
  );
};

export default Home;
